<template>
  <div class="detail">
    <div class="img-con-banner" @click="showBanner(bannerList, 0)">
      <swiper v-if="bannerList && bannerList.length" :list="bannerList" />
      <div class="top-icon"></div>
    </div>
    <!-- status 1:处理中 2:已反馈 3.不合格 4.已完成 -->
    <div class="line">基础描述</div>
    <div class="foot">
      <div class="item">
        <div class="v1">督查点位：</div>
        <div class="v1">
          {{ detail.point_name }}
        </div>
      </div>
      <div class="item inspect">
        <div class="v1 inspect-title">考察内容：</div>
        <div class="v1 inspect-content">
          {{ detail.cate_name }}
        </div>
      </div>
      <!-- <div class="item">
        <div class="v1">责任部门：</div>
        <div class="v1">
          {{ detail.area_name }}
        </div>
      </div>
      <div class="item">
        <div class="v1">整改期限：</div>
        <div class="v1">
          {{ detail.expire_time_text }}
        </div>
      </div> -->
      <div class="item">
        <div class="v1">详细地址：</div>
        <div class="address">
          {{ detail.address }}
        </div>
      </div>
      <div class="item-content">
        <div class="v1">事件描述：</div>
        <div>
          <!-- <textarea v-model="detail.content" readonly></textarea> -->
          {{ detail.content }}
        </div>
      </div>
      <!-- 重新指派 -->
      <div class="item" @click="show = true">
        <div>整改期限</div>
        <div>{{ time }}</div>
      </div>
      <div class="item" id="depart" @click="branchShow = true">
        <div>责任部门</div>
        <div>
          {{ branch }}
          <img
            v-if="!branch"
            src="../../../assets/images/mine/jiantou.png"
            alt=""
          />
        </div>
      </div>
      <div class="item suggestion">
        <div class="title">整改建议</div>
        <div>
          <textarea placeholder="请简单描述..." v-model="suggestion"></textarea>
        </div>
      </div>
      <div class="send-btn" @click="sendOrder">立即派单</div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="settime"
      />
    </van-popup>
    <van-popup
      v-model="branchShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div class="area-container">
        <div class="btn-wrap">
          <div class="cancel-btn btn" @click="closeDialog">取消</div>
          <div class="confirm-btn btn" @click="closeDialog">确定</div>
        </div>
        <div class="area-list">
          <div
            :class="selectedIndexes.includes(i) ? 'active' : ''"
            v-for="(item, i) in areaList"
            :key="i"
            @click="selectArea(item, i)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Swiper from "@/components/Swiper";
import upload from "@/components/Upload";
import { getMyEventDetail, changeWork, assignNew } from "../api";
import { mapActions, mapGetters } from "vuex";
import {
  sendOrder,
  getAreaList,
  getCateList,
  getDepartmentList,
} from "../../report/api";
import { Dialog } from "vant";
import { Toast } from "vant";
import { ImagePreview } from "vant";
export default {
  components: {
    Swiper,
    [Dialog.Component.name]: Dialog.Component,
    upload,
  },
  data() {
    return {
      bannerList: [],
      imgList: [],
      detail: {},
      // 支持多选
      selectedIndexes: [],
      selectedIds: [],
      queryData: {},
      img: [],
      content: "",
      time: this.filterTime(new Date()),
      branch: "",
      branch_id: "",
      show: false,
      branchShow: false,
      minDate: new Date(),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      areaList: [],
      suggestion: "",
    };
  },
  created() {
    let id = this.$route.query.id;
    this.init(id);
  },
  computed: {
    ...mapGetters({
      cateGet: "cate/get",
    }),
    pointData() {
      return this.cateGet("point");
    },
    form() {
      return this.cateGet("form");
    },
    cateContent() {
      return this.cateGet("cateContent");
    },
    departList() {
      return this.cateGet("departList");
    },
  },
  watch: {
    cateContent(v) {
      this.title = v;
    },
    form(v) {
      this.cate = v.cate;
      this.address = v.address;
      this.imgList = v.img;
      this.content = v.content;
      this.time = v.timelimit;
      this.branch_id = v.area_id;
    },
  },
  methods: {
    init(id) {
      let params = {
        id: id,
      };
      getMyEventDetail(params).then((res) => {
        console.log("res", res);
        this.detail = res.data;
        let category_id = res.data.category_id;
        category_id && this.getDepartmentList(category_id);
        this.bannerList = this.detail.img.map((e) => {
          return this.$IMG_PATH + e;
        });
      });
    },
    showImg(imgList, index) {
      let imgs = [];
      imgList.forEach((item) => {
        imgs.push(this.$IMG_PATH + item);
      });
      this.instance_show = ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    showBanner(imgList, index) {
      this.instance_show = ImagePreview({
        images: imgList,
        startPosition: index,
      });
    },
    // 重新指派
    ...mapActions({
      clear: "cate/clear",
      setOrder: "cate/setOrder",
    }),
    filterTime(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
      return y + "-" + m + "-" + d;
    },
    settime(val) {
      this.show = false;
      this.time = this.getTime(val);
      // console.log("选中的时间", this.time);
    },
    getTime(data) {
      let month = Number(data.getMonth()) + 1;
      let day = data.getDate();
      return (
        data.getFullYear().toString() +
        "-" +
        (month > 9 ? month : "0" + month) +
        "-" +
        (day > 9 ? day : "0" + day)
      );
    },
    // 部门列表
    getDepartmentList(id) {
      let params = {
        id: id,
      };
      getDepartmentList(params).then((res) => {
        this.areaList = res.data.department;
        // 如果已有 detail.area_id，则恢复已选状态（支持逗号分隔 id）
        if (this.detail && this.detail.area_id) {
          this.selectedIds = String(this.detail.area_id).split(",");
          // 计算索引
          this.selectedIndexes = [];
          this.selectedIds.forEach((id) => {
            const idx = this.areaList.findIndex(
              (d) => String(d.id) === String(id)
            );
            if (idx > -1) this.selectedIndexes.push(idx);
          });
          this.updateBranchFromIds();
        }
      });
    },
    // 选择部门（多选切换）
    selectArea(item, i) {
      const idxPos = this.selectedIndexes.indexOf(i);
      if (idxPos > -1) {
        this.selectedIndexes.splice(idxPos, 1);
        const idPos = this.selectedIds.indexOf(String(item.id));
        if (idPos > -1) this.selectedIds.splice(idPos, 1);
      } else {
        this.selectedIndexes.push(i);
        this.selectedIds.push(String(item.id));
      }
      this.updateBranchFromIds();
    },
    updateBranchFromIds() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        this.branch = "";
        this.branch_id = "";
        return;
      }
      this.branch_id = this.selectedIds.join(",");
      if (this.areaList && this.areaList.length) {
        const names = [];
        this.selectedIds.forEach((id) => {
          const found = this.areaList.find((d) => String(d.id) === String(id));
          if (found) names.push(found.name);
        });
        this.branch = names.join(",") || this.selectedIds.join(",");
      } else {
        this.branch = this.selectedIds.join(",");
      }
    },
    closeDialog() {
      this.branchShow = false;
    },
    // 派单
    async sendOrder() {
      if (!this.time) {
        this.$toast.fail("请选择整改期限时间");
      } else if (!this.branch) {
        this.$toast.fail("请选择责任部门");
      } else {
        this.$toast.loading({ duration: 0, message: "派单中" });
        let params = {
          id: this.detail.id,
          area_id: this.branch_id,
          timelimit: this.time,
          token: window.localStorage.getItem("token"),
          suggestion: this.suggestion,
        };
        params.token = window.localStorage.getItem("token");
        console.log("参数", params);
        sendOrder(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            this.$toast.clear();
            this.$toast.success("派单成功!");
            this.clear();
            setTimeout(() => {
              this.$router.replace("/");
            }, 1200);
          } else {
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0.24rem 0.3rem 0.54rem;
  overflow: hidden;
  .img-con-banner {
    width: 100%;
    height: 3.9rem;
    overflow: hidden;
    margin-bottom: 0.24rem;
    position: relative;
    /deep/.swiper {
      width: 100%;
      height: 3.9rem !important;
      overflow: hidden;
    }
    /deep/ img {
      width: 100%;
      height: 3.9rem !important;
      display: block;
      border-radius: 0.08rem;
    }
    .top-icon {
      width: 1.4rem;
      height: 0.72rem;
      position: absolute;
      top: 8%;
      right: 0;
    }
    .bg-1 {
      background-image: url("../../../assets/images/mine/3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-2 {
      background-image: url("../../../assets/images/mine/5.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-3 {
      background-image: url("../../../assets/images/mine/8.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bg-4 {
      background-image: url("../../../assets/images/mine/9.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .line {
    width: 100%;
    height: 0.4rem;
    padding-left: 0.14rem;
    border-left: 0.14rem solid #1883fe;
    margin-top: 0.2rem;
  }
  .foot {
    width: 100%;
    min-height: 6rem;
    background-color: #fff;
    border-radius: 0.14rem;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
    padding-bottom: 20px;
    > div:first-child {
      > div:last-child {
        // max-width: 3rem;
        height: 40px;
        margin-top: 0.15rem;
        line-height: 0.6rem;
        // text-align: center;
        color: #999;
        // font-size: 16px;
        border-radius: 0.1rem;
        // background-color: #fda143;
      }
    }
    > div:last-child {
      border: none;
    }
    .item {
      display: flex;
      min-height: 0.9rem;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      display: flex;
      align-items: center;
      > div:first-child {
        width: 2rem;
      }
      > div:last-child {
        width: calc(100% - 2rem);
        color: #999;
      }
    }
    #depart {
      div:last-child {
        float: right;
        text-align: left;
        img {
          width: 6.6px;
          height: 12px;
          margin-left: 85%;
        }
      }
    }
    .suggestion {
      flex-direction: column;
      align-items: flex-start;
      .title {
        margin: 10px 0;
      }
      textarea {
        width: 338px;
        height: 2.8rem;
        border: 0.02rem solid rgba(225, 225, 225, 1);
        border-radius: 6px;
        padding: 10px;
        background: rgba(244, 246, 248, 1);
        resize: none;
      }
      textarea::-webkit-input-placeholder {
        color: #969799;
      }
    }
    .inspect {
      // height: 60px;
      // .inspect-title {
      //   margin-bottom: 15px;
      // }
      .inspect-content {
        text-align: initial !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        // word-break: break-all;
        // line-height: 20px !important;
      }
    }
    .item-content {
      width: 100%;
      border-bottom: 1px solid rgba(112, 112, 112, 0.1);
      > div:first-child {
        width: 2rem;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        min-height: 1rem;
        padding: 10px;
        color: #999;
        border: 1px solid rgba(112, 112, 112, 0.1);
        border-bottom: none;
        textarea {
          width: 100%;
          min-height: 2rem;
          padding: 0.1rem;
          border: none;
        }
      }
    }
    .item-content-m {
      width: 100%;
      > div:first-child {
        width: 100%;
        height: 0.9rem;
        line-height: 0.9rem;
      }
      > div:last-child {
        width: 100%;
        height: 1.4rem;
        color: #999;
        textarea {
          width: 100%;
          height: 100%;
          padding: 0.1rem;
          border: 1px solid rgba(112, 112, 112, 0.1);
        }
      }
    }
  }
  // 弹出层
  ::v-deep .van-popup {
    overflow: hidden;
  }
  .area-container {
    .btn-wrap {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        // width: 30px;
        height: 20px;
        font-size: 15px;
      }
      .cancel-btn {
        color: #999999;
        margin-left: 30px;
      }
      .confirm-btn {
        color: #206aff;
        margin-right: 30px;
      }
    }
    .area-list {
      height: 200px;
      overflow-y: auto;
      margin-top: 5px;
      margin-left: 30px;
      margin-right: 30px;
      padding-bottom: 35px;
      display: flex;
      // justify-content: space-around;
      flex-wrap: wrap;
      div {
        margin-right: 15px;
        height: 34px;
        padding: 0 15px;
        line-height: 34px;
        font-size: 12px;
        color: #999999;
        background: rgba(238, 242, 241, 1);
        text-align: center;
        margin-bottom: 10px;
        border-radius: 2px;
      }
      .active {
        color: #ffffff;
        background: #206aff;
      }
    }
  }
  .btns {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    color: #fff;
    text-align: center;
    font-size: 0.32rem;
    display: flex;
    > div {
      flex: 1;
      height: 100%;
    }
    .v1 {
      background-image: linear-gradient(to right, #fc9227, #febe76);
    }
    .v2 {
      background-image: linear-gradient(to right, #277cfc, #4dacff);
    }
  }
  .all {
    width: 100%;
    min-height: 0.84rem;
    margin-bottom: 0.2rem;
    .item-all {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 0.84rem;
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 0.15rem;
      color: #333;
      background: rgba(245, 245, 245, 1);
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 4px;
      color: #666666;
      font-size: 14px;
      padding: 0 0.3rem;
      margin-top: 0.2rem;
      .img-con {
        width: 0.3rem;
        height: 0.3rem;
      }
      div {
        width: 1rem;
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      input {
        width: 100%;
        height: 0.84rem;
        background-color: #f5f5f5;
        border: none;
      }
    }
  }
  .send-btn {
    // position: fixed;
    // left: 18px;
    // right: 18px;
    // bottom: 32px;
    height: 50px;
    color: #fff;
    font-size: 16px;
    line-height: 50px;
    background-color: #206aff;
    text-align: center;
    cursor: pointer;
    margin-top: 30px;
    // margin-bottom: 10px;
    border-radius: 0.14rem;
  }
}
</style>